import React, { useState , useEffect  } from 'react';
import { FaTimes } from 'react-icons/fa';
import axios from '../../../services/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const StartCommunityServiceModal = ({ isOpen, onClose, community, onSuccess }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    startTime: '',
    endTime: ''
  });

  useEffect(() => {
    if (isOpen && !community.startTime) {
      setFormData({
        startTime: '',
        endTime: ''
      });
      const fetchContracts = async () => {
        try {
          const response = await axios.get(`/contracts/${community._id}`);
          if (response.data && response.data.length > 0 ) {
            setFormData({
              startTime: moment(response.data[response.data.length-1].startDate).format('YYYY-MM-DD'),
              endTime: moment(response.data[response.data.length-1].endDate).format('YYYY-MM-DD')
            });
          }
        } catch (error) {
          console.log(error);
        }
      };
      fetchContracts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
    // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleSubmit = async () => {
    // Add validation for start time < end time
    if (new Date(formData.endTime) <= new Date(formData.startTime)) {
      toast.error(t('Service time error'));
      return;
    }

    try {
      const data = {
        communityId: community._id,
        // Set start time to beginning of day (00:00:00)
        startTime: new Date(formData.startTime).setHours(0, 0, 0, 0),
        // Set end time to end of day (23:59:59)
        endTime: new Date(formData.endTime).setHours(23, 59, 59, 999)
      };

      await axios.post(`/communities/start-service`, data);
      onSuccess();
      onClose();
    } catch (error) {
      console.log(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[15%] pt-[7%] z-[60]">
      <div className="bg-white w-[30vw] h-[55vh] rounded-lg shadow-xl relative">
        <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
          <h2 className="text-lg font-semibold">{t('Start Service')}</h2>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="p-4 h-[calc(55vh-116px)] overflow-y-auto">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">{t('Start Time')}</label>
              <input
                type="date"
                value={formData.startTime}
                onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">{t('End Time')}</label>
              <input
                type="date"
                value={formData.endTime}
                onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 px-4 py-3 border-t bg-white">
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              className="px-4 py-1.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
            >
              {t('Cancel')}
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              {t('Save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartCommunityServiceModal;
